var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container",attrs:{"role":"button"},on:{"click":_vm.updateValue}},[_c('div',{class:[
      _vm.correct && _vm.solving ? 'correct' : '',
      !_vm.correct && _vm.solving ? 'incorrect' : '',
      'custom-check',
    ]},[_c('div',{class:[_vm.check ? 'checked' : '', 'fill']},[(_vm.solving && _vm.correct && _vm.check)?_c('div',{staticClass:"icon"},[_vm._v("✓")]):_vm._e(),(_vm.solving && !_vm.correct && _vm.check)?_c('div',{staticClass:"icon"},[_vm._v("✖")]):_vm._e()])]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }